module.exports = __webpack_public_path__ + "static/media/Illus-Nutrition_2.42ca725c.png";